module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image20-4adc8500a98c9edaf7c688bab814cbeb.jpg";